export enum EDiffType {
  VERSION = 'VERSION',
  DEVVERSION = 'DEVVERSION',
  FILE = 'FILE',
}
